import { render, staticRenderFns } from "./CampanhaInternaPopupBlocks.vue?vue&type=template&id=30d43c16"
import script from "./CampanhaInternaPopupBlocks.vue?vue&type=script&lang=js"
export * from "./CampanhaInternaPopupBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports